import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Users } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useResidentes } from '@/features/residentes/api';
import { ResidentesTable } from '@/features/residentes/residentes-table';
import { ResidenteForm } from '@/features/residentes/residente-form';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { EmptyState } from '@/components/common/empty-state';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';

export function ResidentesRoute() {
  const { condoId } = useCondoContext();
  const { data, isLoading } = useResidentes(condoId);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const residentes = data?.items ?? [];

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Directorio"
        title="Residentes"
        subtitle="Propietarios y arrendatarios vinculados a unidades del condominio."
        action={
          <Button onClick={() => setOpen(true)}>
            <Plus className="h-4 w-4" />
            Nuevo residente
          </Button>
        }
      />

      {residentes.length === 0 && !isLoading ? (
        <EmptyState
          icon={<Users className="h-5 w-5" />}
          title="Aun no hay residentes"
          description="Crea el primer residente para poder asignarle una unidad y comenzar a emitir gastos comunes."
          action={
            <Button onClick={() => setOpen(true)}>
              <Plus className="h-4 w-4" />
              Crear residente
            </Button>
          }
        />
      ) : (
        <ResidentesTable
          data={residentes}
          isLoading={isLoading}
          onRowClick={(r) => navigate(`/app/condominios/${condoId}/residentes/${r.id}`)}
        />
      )}

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-md">
          <SheetHeader>
            <SheetTitle>Nuevo residente</SheetTitle>
            <SheetDescription>
              Registra a un propietario o arrendatario. Podras asignarlo a una
              unidad luego de crearlo.
            </SheetDescription>
          </SheetHeader>
          <div className="mt-6">
            <ResidenteForm
              condoId={condoId}
              onCreated={() => setOpen(false)}
              onCancel={() => setOpen(false)}
            />
          </div>
        </SheetContent>
      </Sheet>
    </PageContainer>
  );
}
